import { PlacesType } from 'react-tooltip';
import { useSelector } from 'react-redux';
import { RootReducer } from 'redux/reducers';
import { selectIsMobile } from 'redux/mode/reducers';
import * as S from './styles';
import { createPortal } from 'react-dom';

interface TooltipProps {
	placement: PlacesType;
	id: string;
}

export const Tooltip = ({ placement, id }: TooltipProps) => {
	const isMobile = useSelector((r: RootReducer) => selectIsMobile(r.mode));

	// Don't show tooltips on mobile
	if (isMobile) {
		return null;
	}

	// I wanted to set this to something darker than the background
	// in dark mode. Turns out that unthemed.gray['1000'] is the right value
	// However when I pass it in, the Tooltip ends up slightly lighter than that.
	// It's pretty frustrating. Styling this tooltip is actually quite intricate.
	// I found out that setting it to #000000 results in #0D0D0D which is dark
	// enough for our purposes.
	// We may end up changing our tooltip system entirely as I could see us wanting
	// more customization in the future.
	return createPortal(
		<S.StyledTooltip
			id={id}
			delayShow={500}
			place={placement}
			positionStrategy="fixed"
			style={{
				zIndex: 9999,
				background: '#000000',
				pointerEvents: 'none',
				maxWidth: 280,
				whiteSpace: 'normal',
				lineHeight: 1.35,
			}}
		/>,
		document.body
	);
};
